/* eslint-disable import/no-cycle */

import angular, { IScope, ITimeoutService } from 'angular';
import { InterfaceService } from '../../shared/interface/interface.service';
import { ConstantsService } from '../../shared/config/constants.service';

export const enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

interface Toast {
  type: ToastType,
  message: string,
  id: number,
}

interface RootScope extends IScope {
  pageLoadComplete: boolean,
  toasts: Toast[],
}

/* @ngInject */
export class ToastService {
  private ConstantsService: { [key: string]: any };

  private $rootScope: RootScope;

  private $timeout: ITimeoutService;

  private interfaceService: InterfaceService;

  constructor(
    $rootScope: RootScope,
    $timeout: ITimeoutService,
    interfaceService: InterfaceService,
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.interfaceService = interfaceService;
    this.ConstantsService = ConstantsService;

    this.$rootScope.toasts = [];
  }

  /** Shows an error toast and logs the error to the console */
  public error = (error: Error): void => {
    this.toast(ToastType.ERROR, error.message);
    console.error(error);
  };

  public toast = (type: ToastType, message: string): void => {
    // Prevent errors from appearing before app launch is completed
    if (!this.$rootScope.pageLoadComplete) return;

    const id = Math.random();
    this.$rootScope.toasts.push({
      type,
      message,
      id,
    });

    this.interfaceService.applyScope(this.$rootScope);

    this.$timeout(() => {
      this.removeToast(id);
    }, this.ConstantsService.interfaceToastDuration);
  };

  public removeToast = (toastId: number): void => {
    this.$rootScope.toasts = this.$rootScope.toasts.filter((t) => t.id !== toastId);
  };
}

export default angular.module('services.toastService', [])
  .service('toastService', ToastService)
  .name;
